import type { PreNominationValidatedFormData } from "@features/vessel-nomination/pre-nomination-request/schema/preNominationRequestSchema";
import type { VesselPreNominationRequestPayload } from "@services/vessel-nomination/types";
import { toDate } from "@utils/date-time";

const trimToUndefined = (value?: string) => {
  const trimmedValue = value?.trim();

  return trimmedValue || undefined;
};

const mapAttachments = (
  attachments: PreNominationValidatedFormData["attachments"],
): VesselPreNominationRequestPayload["documents"] =>
  attachments
    .filter((attachment) => attachment.documentUrl)
    .map((attachment) => ({
      fileUrl: attachment.documentUrl!,
      documentType: attachment.documentType,
      otherSpecify: trimToUndefined(attachment.otherSpecify),
      issueDate: toDate(attachment.issueDate)?.toISOString(),
      expiryDate: toDate(attachment.expirationDate)?.toISOString(),
      documentName: attachment.documentName,
      documentSummary: trimToUndefined(attachment.documentSummary),
    }));

const mapPreNominationRequestToPayload = (
  formData: PreNominationValidatedFormData,
): VesselPreNominationRequestPayload => ({
  vesselId: formData.vesselId,
  eta: toDate(formData.eta)?.toISOString() || "",
  callSign: formData.callSign,
  deadWeight: {
    summerDwt: formData.summerDwt,
  },
  arrivalDraft: formData.arrivalDraft,
  departureDraft: formData.departureDraft,
  hasHullProtrusion: formData.hasHullProtrusion === true,
  parcels: formData.parcels.map((parcel) => ({
    ...(parcel.id ? { id: parcel.id } : {}),
    customerTerminal: {
      companyCode: parcel.terminal,
    },
    operationType: parcel.operationType,
    cargoType: {
      cargoCode: parcel.cargoType,
    },
    cargoQuantityCbm: parcel.cargoQuantityCbm,
    cargoQuantityMt: parcel.cargoQuantityMt,
  })),
  remarks: trimToUndefined(formData.remarks),
  documents: mapAttachments(formData.attachments),
});

export default mapPreNominationRequestToPayload;
